/* Keep the assigned Kaching offer consistent when an exposed visitor uses Mix & Match. */
(() => {
  const config = document.getElementById('pluffi-fr-price-test');
  if (!config) return;
  const country = config.dataset.country;
  if (!['FR', 'BE', 'DE', 'ES', 'IT'].includes(country)) return;
  const key = 'pluffi-eu-price-20261016';
  const blockId = '67ebf5cc-2393-4226-8b3f-0cf753becbae';
  const valid = value => value && ['A', 'B'].includes(value.variant) && value.expires > Date.now();
  let current;
  try { const saved = JSON.parse(localStorage.getItem(key)); if (valid(saved)) current = saved; } catch (_) {}
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:'EUR'}).format(cents / 100);
  window.PluffiPriceTest = {
    get variant() { return current?.variant || null; },
    get property() { return current ? 'eu-20261016:' + current.variant : ''; },
    get variantId() { return current?.variantId || ''; },
    extra(quantity, kids = 0) { return current?.variant === 'B' && quantity > kids ? 500 : 0; },
    unitPrice() { return current?.variant === 'B' ? 3990 : 3490; }
  };
  const lang = document.documentElement.lang.slice(0, 2);
  const adultIds = new Set(['9609564488016','10337135984976','10201092391248','10663896449360','9604511793488','10205556310352','9598568628560','10337136968016','10337145192784']);
  const putText = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
  function syncCartReference() {
    if (current?.variant !== 'A') return;
    let correction = 0;
    const seen = new Set();
    document.querySelectorAll('.cart-items__table-row[data-pluffi-product-id]').forEach(row => {
      if (!adultIds.has(row.dataset.pluffiProductId) || Number(row.dataset.pluffiOriginalUnit) !== 3990) return;
      const qty = Number(row.dataset.pluffiQuantity);
      const final = Number(row.dataset.pluffiFinalLine);
      const reference = 3490 * qty;
      if (!(qty > 0) || !Number.isFinite(final) || final > reference) return;
      if (!seen.has(row.dataset.key)) { correction += 500 * qty; seen.add(row.dataset.key); }
      const savings = reference - final;
      const unitCompare = row.querySelector('.cart-items__details .compare-at-price');
      const totalCompare = row.querySelector('.cart-items__price .compare-at-price');
      [unitCompare, totalCompare].forEach(el => { if (el) el.style.display = savings === 0 ? 'none' : ''; });
      if (unitCompare) {
        putText(unitCompare, money(3490));
        if (unitCompare.previousElementSibling?.classList.contains('visually-hidden')) unitCompare.previousElementSibling.hidden = savings === 0;
        if (savings === 0) putText(unitCompare.parentElement.querySelector('.visually-hidden'), {fr:'Prix',de:'Preis',es:'Precio',it:'Prezzo'}[lang] || 'Price');
      }
      putText(totalCompare, money(reference));
      const saved = row.querySelector('.cart-items__save-price');
      if (saved) {
        saved.style.display = savings === 0 ? 'none' : '';
        const label = {fr:'Économies',de:'Ersparnis',es:'Ahorro',it:'Risparmio'}[lang] || 'Savings';
        putText(saved.querySelector('.cart-items__save-price-label'), label + ' ' + money(savings));
      }
    });
    document.querySelectorAll('[data-pluffi-original-savings]').forEach(el => {
      const savings = Math.max(0, Number(el.dataset.pluffiOriginalSavings) - correction);
      el.style.display = savings === 0 ? 'none' : '';
      putText(el.querySelector('.cart__savings-value'), '−' + money(savings));
    });
  }
  function sync() {
    const block = document.querySelector('.kaching-bundles__block[data-deal-block-id="' + blockId + '"]');
    const variant = block?.getAttribute('data-ab-test-variant');
    if (variant === 'A' || variant === 'B') {
      const changed = current?.variant !== variant;
      current = {variant, variantId:block.getAttribute('data-ab-test-variant-id') || '', expires:Date.now()+90*86400000};
      try { localStorage.setItem(key, JSON.stringify(current)); } catch (_) {}
      if (changed) window.dispatchEvent(new Event('pluffi-price-test-ready'));
    }
    // Keep the comparison coherent during the transition and within each assigned offer.
    const oldIds = ['d626e841-6b04-438a-8df7-d91dfce309ec','9fbac668-e47d-4960-a4c7-f320c5235c03'];
    document.querySelectorAll('.kaching-bundles__block').forEach(offer => {
      const id = offer.getAttribute('data-deal-block-id');
      if (id !== blockId && !oldIds.includes(id)) return;
      const unit = id === blockId && variant === 'B' ? 3990 : 3490;
      offer.querySelectorAll('.kaching-bundles__upsell__full-price').forEach(el => putText(el, money(unit)));
      offer.querySelectorAll('.kaching-bundles__bar').forEach((bar, index) => {
        if (index > 2) return;
        const full = bar.querySelector('.kaching-bundles__bar-full-price');
        if (!full) return;
        if (index === 0) { full.style.display = 'none'; return; }
        const text = money(unit * (index + 1));
        if (full.textContent.trim() !== text) full.textContent = text;
        const label = {fr:'Prix des paires achetées séparément',de:'Preis der einzeln gekauften Paare',es:'Precio de los pares comprados por separado',it:'Prezzo delle paia acquistate singolarmente'}[lang] || 'Price of pairs bought separately';
        full.setAttribute('aria-label', label + ' : ' + text);
      });
    });
    if (!current) return;
    syncCartReference();
    const higher = current.variant === 'B';
    document.querySelectorAll('.pluffi-eu-announcement').forEach(el => {
      if (!el.dataset.priceTestOriginal) el.dataset.priceTestOriginal = el.textContent;
      const text = higher ? el.dataset.priceTestOriginal.replace(/25\s*€/g, '35 €') : el.dataset.priceTestOriginal;
      if (el.textContent !== text) el.textContent = text;
    });
  }
  let pending = false;
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(() => { pending = false; sync(); }); } };
  new MutationObserver(schedule).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['data-ab-test-variant', 'data-ab-test-variant-id']});
  sync();
})();
